{
    "Accessibility menu": "Izbornik pristupačnosti",
    "Close": "Zatvori",
    "Content adjustments": "Prilagodbe sadržaja",
    "Navigation adjustments": "Prilagodbe navigacije",
    "Text Align": "Poravnanje teksta",
    "Align Left": "Poravnaj lijevo",
    "Align Center": "Poravnaj na sredinu",
    "Align Right": "Poravnaj desno",
    "Adjust Font Size": "Prilagodi veličinu fonta",
    "Highlight Title": "Istakni naslov",
    "Highlight Links": "Istakni poveznice",
    "Readable Font": "Čitljiv font",
    "Colour adjustments": "Prilagodbe boja",
    "Dark Contrast": "Tamni kontrast",
    "Light Contrast": "Svijetli kontrast",
    "High Contrast": "Visoki kontrast",
    "High Saturation": "Visoka zasićenost",
    "Low Saturation": "Niska zasićenost",
    "Monochrome": "Jednobojno",
    "Tools": "Alati",
    "Reading Guide": "Vodič za čitanje",
    "Big Cursor": "Veliki kursor",
    "Increase Font Size": "Povećaj veličinu fonta",
    "Decrease Font Size": "Smanji veličinu fonta",
    "Letter Spacing": "Razmak između slova",
    "Line Height": "Visina linije",
    "Font Weight": "Debljina fonta",
    "Dyslexia Font": "Font za disleksiju",
    "Language": "Jezik",
    "Accessibility widget": "Otvori izbornik pristupačnosti",
    "Accessibility Profiles": "Profili pristupačnosti",
    "Cognitive Disability": "Kognitivni invaliditet",
    "Seizure Safe": "Sigurno za epilepsiju",
    "Accessibility statement": "Izjava o pristupačnosti",
    "ADHD": "ADHD",
    "Low Vision": "Slabovidnost",
    "Pause Animations": "Zaustavi animacije",
    "Animation paused": "Animacija pauzirana",
    "Reset all settings": "Resetiraj postavke",
    "Shortcut:": "Prečac:",
    "Epilepsy Safe Mode": "Način siguran za epilepsiju",
    "Mute sounds": "Isključi zvukove",
    "Page read": "Čitanje stranice",
    "Page read controls": "Kontrole čitanja stranice",
    "Pause": "Pauziraj",
    "Resume": "Nastavi",
    "Stop": "Zaustavi",
    "Settings": "Postavke",
    "Speed": "Brzina",
    "Voice": "Glas",
    "Close accessibility menu": "Zatvori izbornik pristupačnosti",
    "Back to accessibility menu": "Natrag na izbornik pristupačnosti",
    "Search languages": "Pretraži jezike",
    "Selected language": "Odabrani jezik",
    "View accessibility statement (opens in new window)": "Prikaži izjavu o pristupačnosti (otvara se u novom prozoru)",
    "Visit CookieYes website (opens in new window)": "Posjeti web-stranicu CookieYes (otvara se u novom prozoru)",
    "Reset all accessibility settings to default": "Vrati sve postavke pristupačnosti na zadano"
}
